var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"loader",class:_vm.props.size},[_c('div',{staticClass:"loader-spinner"})])}
var staticRenderFns = []

export { render, staticRenderFns }